import { Status } from './MiniPriceChart/styled';

interface ChartStatusProps {
  status: 'pending' | 'error' | 'success';
  height: number;
  hasData: boolean;
}

export const ChartStatus = ({ status, height, hasData }: ChartStatusProps) => {
  if (status === 'pending') {
    return (
      <Status role="status" height={height}>
        Loading
      </Status>
    );
  }

  if (status === 'error') {
    return (
      <Status role="status" height={height}>
        An error occurred
      </Status>
    );
  }

  if (status === 'success' && !hasData) {
    return (
      <Status role="status" height={height}>
        No data
      </Status>
    );
  }

  return null;
};
